import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { httpAdmin, limitToTwoDecimal } from "../../../Apis/commonApis";
import { currentCareSiteId } from "../../../redux-toolkit/reducer/switchSites";
import {
  currentTimeZone,
  disablePastDate,
  getCurrentTimeZone,
  getDatesOfSelectedDays,
  getFullName,
  getNameChars,
} from "../../../utils/CommonFunctions";
import { jobTitleOptions, timeValues } from "../../../constants/constants";
import moment from "moment";
import { convertToUTCWithTimezone } from "../../../utils/datechangehandler";
import { ShowSwal } from "../../../utils/alertSwal";
import LoadingBtn from "../../../components/Toggle_Button/LoadingBtn";

const clientGroupImg = "/images/clientGroup.svg";

const weekDayOptions = ["all", "mon", "tue", "wed", "thu", "fri", "sat", "sun"];

const ShiftCreationAgency = (props) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    getValues,
    setValue,
    watch,
    clearErrors,
  } = useForm({
    defaultValues: { priorityBasedOnType: "weeklyHoursAssigned" },
  });

  const [clientOptions, setClientOptions] = useState([]);
  const [isRecurring, setIsRecurring] = useState(false);
  const [selectedDays, setSelectedDays] = useState(weekDayOptions);
  const [isOpenShift, setIsOpenShift] = useState(false);
  const [isAssignStaff, setIsAssignStaff] = useState(false);
  const [createdShifts, setCreatedShifts] = useState([]);
  const [alertModal, setAlertModal] = useState({
    show: false,
    title: "",
    message: "",
  });
  const [staffCriteria, setStaffCriteria] = useState("weeklyHoursAssigned");
  const [jobTitleFilter, setJobTitleFilter] = useState("");
  const [availableStaffData, setAvailableStaffData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    title: "",
    message: "",
    onConfirm: null,
  });

  const timeOptions = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const timeString = `${hour.toString().padStart(2, "0")}:${minute
        .toString()
        .padStart(2, "0")}`;
      timeOptions.push(timeString);
    }
  }

  useEffect(() => {
    searchForApi();
  }, []);

  const searchForApi = async () => {
    let data = {
      name: "",
      careHomeId: currentCareSiteId,
    };
    const response = await httpAdmin("filterFor", "post", data, null);
    let filteredData = [];
    response.clientData?.forEach((elem) => {
      let clintName = elem?.first_Name
        ? getFullName(elem)
        : // `${elem?.first_Name} ${elem.last_Name}`
          `${elem.groupName}`;
      filteredData.push({
        value: elem._id,
        clientGroup: elem.clientGroup,
        label: (
          <div>
            <img
              src={elem.groupName ? clientGroupImg : elem.image}
              height="30px"
              width="30px"
            />{" "}
            {clintName}{" "}
          </div>
        ),
        name: clintName,
      });
    });
    setClientOptions(filteredData);
  };

  useEffect(() => {
    const startDateValue = watch("date", "");
    const endDateValue = isRecurring ? watch("endDate", "") : watch("date", "");
    const startTimeValue = watch("startTime", "");
    const endTimeValue = watch("endTime", "");
    const clientSelected = watch("for", "");
    const isAllFieldsFilled =
      startDateValue !== "" &&
      endDateValue !== "" &&
      startTimeValue !== "" &&
      clientSelected !== "" &&
      endTimeValue !== "";
    if (isAssignStaff && isAllFieldsFilled) {
      getAvailableCareTeam(
        startDateValue,
        endDateValue,
        startTimeValue,
        endTimeValue,
        clientSelected
      );
    } else {
      setAvailableStaffData([]);
    }
  }, [
    jobTitleFilter,
    staffCriteria,
    watch("startTime", ""),
    watch("endTime", ""),
    watch("date", ""),
    watch("endDate", ""),
    watch("for", ""),
    isAssignStaff,
  ]);

  const getAvailableCareTeam = async (
    startDateValue,
    endDateValue,
    startTimeValue,
    endTimeValue,
    client
  ) => {
    const data = {
      careSiteId: currentCareSiteId,
      priorityBasedOn: staffCriteria,
      // shiftName: filters?.shiftName,
      jobTitle: jobTitleFilter,
      clientId: client,
      shiftDates: [
        {
          date: startDateValue,
          startTime: startTimeValue,
          endTime: endTimeValue,
        },
      ],
      startDate: startDateValue,
      endDate: endDateValue,
    };
    if (isRecurring) {
      let shiftDates = [];
      const datesOfSelectedDays = getDatesOfSelectedDays(
        startDateValue,
        endDateValue,
        selectedDays
      );
      datesOfSelectedDays.forEach((elem) => {
        shiftDates.push({
          date: elem?.split("T")[0],
          startTime: startTimeValue,
          endTime: endTimeValue,
        });
      });
      data.shiftDates = shiftDates;
    }
    const res = await httpAdmin("availableCareMember", "post", data, null);
    if (res.status) {
      let teamdata = [];
      res.data?.forEach((item) => {
        teamdata.push({
          id: item._id,
          name: getFullName(item),
          //  `${item.first_Name} ${item.last_Name}`,
          image: item.image,
          role: item.jobTitle ?? "",
          jobTitle: item.jobTitle ?? "",
          clientGroup: "all",
          avatar: getNameChars(item),
          hours: item.totalHours ? limitToTwoDecimal(+item.totalHours) : "0",
          weeklyHoursAssigned: item.totalHours
            ? limitToTwoDecimal(+item.totalHours)
            : 0,
          performance: item.averagePerformance
            ? limitToTwoDecimal(+item.averagePerformance)
            : 0,
          distance: item.distance ? limitToTwoDecimal(+item.distance) : 0,
          selected: false,
        });
      });
      const sortTeamData = sortArrayByKey(teamdata, staffCriteria);
      setAvailableStaffData(sortTeamData);
    } else {
      setAvailableStaffData([]);
    }
  };

  const handleDayToggle = (day) => {
    if (day === "all") {
      if (selectedDays.includes("all")) {
        setSelectedDays([]);
      } else {
        setSelectedDays(weekDayOptions);
      }
    } else {
      const newDays = selectedDays.includes(day)
        ? selectedDays.filter((d) => d !== day && d !== "all")
        : [...selectedDays.filter((d) => d !== "all"), day];

      if (newDays.length === 7) {
        setSelectedDays(["all", ...newDays]);
      } else {
        setSelectedDays(newDays);
      }
    }
  };

  const handleStaffToggle = (staffId) => {
    setAvailableStaffData((prev) =>
      prev.map((s) => (s.id === staffId ? { ...s, selected: !s.selected } : s))
    );
  };

  const showAlert = (title, message) => {
    setAlertModal({ show: true, title, message });
  };

  const addShift = async (formData) => {
    if (isRecurring) {
      const daysWithoutAll = selectedDays.filter((d) => d !== "ALL");
      if (daysWithoutAll.length === 0) {
        showAlert(
          "Days Selection Required",
          "Please select at least one day for the recurring shift."
        );
        return;
      }
    }
    const userData = JSON.parse(localStorage.getItem("userData"));
    const type = "string";
    const selectedStaff = availableStaffData.filter((sItem) => sItem.selected);
    let shiftdata = [];
    let clientsInGroup = [];
    const findSelectedClient = clientOptions.find(
      (cItem) => cItem.value === formData.for
    );
    if (findSelectedClient.clientGroup.length < 1) {
      clientsInGroup.push({
        name: findSelectedClient.name,
        clientId: findSelectedClient.value,
      });
    } else {
      clientsInGroup.push(
        ...findSelectedClient.clientGroup?.map((item) => ({
          name: getFullName(item),
          clientId: item._id,
        }))
      );
    }

    const shiftType = isOpenShift
      ? "open"
      : isAssignStaff
      ? "assigned"
      : "unassigned";
    if (isRecurring) {
      if (shiftType === "open" || shiftType === "unassigned") {
        let recurringWeekDays = [];

        let getDaysArray = function (startDate, endDate) {
          let dateArray = [];
          for (
            let daysName = new Date(startDate);
            daysName <= new Date(endDate);
            daysName.setDate(daysName.getDate() + 1)
          ) {
            const formatDayName = daysName
              .toString()
              .split(" ")[0]
              ?.toLowerCase();
            selectedDays.forEach((item, index) => {
              if (item === formatDayName) {
                recurringWeekDays.push(formatDayName);
                dateArray.push(new Date(daysName));
              }
            });
          }
          return dateArray;
        };
        let weekdaysDate = getDaysArray(formData.date, formData.endDate);
        weekdaysDate.forEach((shiftStartDate, index) => {
          let date = shiftStartDate.toISOString().split("T")[0];
          clientsInGroup.forEach((elem) => {
            shiftdata.push({
              careHomeId: currentCareSiteId,
              clientId: elem.clientId,
              forClient: elem.name,
              Date: date,
              shiftStartDatetime: convertToUTCWithTimezone(
                date,
                formData.startTime,
                userData?.timeZone
              ),
              shiftEndDatetime: convertToUTCWithTimezone(
                date,
                formData.endTime,
                userData?.timeZone
              ),
              startingTime: formData.startTime,
              endingTime: formData.endTime,
              priorityBasedOn: staffCriteria,
              recurringTask: isRecurring,
              recurringTasktype: selectedDays.join(","),
              instruction: formData.instruction,
              recurringShiftType: shiftType,
              type: type,
              endDate: formData.endDate,
              templateType: "",
              timeZone: currentTimeZone(),
            });
          });
        });
      } else {
        let recurringWeekDays = [];

        let getDaysArray = function (startDate, endDate) {
          let dateArray = [];
          const filterSelectedDays = selectedDays.filter(
            (dItem) => dItem !== "all"
          );
          for (
            let daysName = new Date(startDate);
            daysName <= new Date(endDate);
            daysName.setDate(daysName.getDate() + 1)
          ) {
            const formatDayName = daysName
              .toString()
              .split(" ")[0]
              ?.toLowerCase();
            filterSelectedDays.forEach((item, index) => {
              if (item === formatDayName) {
                recurringWeekDays.push(formatDayName);
                dateArray.push(new Date(daysName));
              }
            });
          }
          return dateArray;
        };

        let weekdaysDate = getDaysArray(formData.date, formData.endDate);
        const assignedTeams = selectedStaff?.map((item) => item.id);
        if (assignedTeams?.length === 0) {
          showAlert(
            "Careteam Selection Required",
            "Please select at least one careteam."
          );
          return;
        }

        weekdaysDate.forEach((shiftStartDate, index) => {
          let date = shiftStartDate.toISOString().split("T")[0];
          clientsInGroup.forEach((elem) => {
            shiftdata.push({
              careHomeId: currentCareSiteId,
              careTeamId: assignedTeams,
              clientId: elem.clientId,
              Date: date,
              shiftStartDatetime: convertToUTCWithTimezone(
                date,
                formData.startTime,
                userData?.timeZone
              ),
              shiftEndDatetime: convertToUTCWithTimezone(
                date,
                formData.endTime,
                userData?.timeZone
              ),
              priorityBasedOn: staffCriteria,

              startingTime: formData.startTime,
              endingTime: formData.endTime,
              recurringTask: isRecurring,
              recurringTasktype: selectedDays.join(","),
              instruction: formData.instruction,
              recurringShiftType: shiftType,
              type: type,
              endDate: formData.endDate,
              templateType: "",
              timeZone: currentTimeZone(),
            });
          });
        });
      }
    } else {
      if (shiftType === "open" || shiftType === "unassigned") {
        clientsInGroup.forEach((elem) => {
          shiftdata.push({
            careHomeId: currentCareSiteId,
            clientId: elem.clientId,
            forClient: elem.name,
            Date: formData.date,
            shiftStartDatetime: convertToUTCWithTimezone(
              formData.date,
              formData.startTime,
              userData?.timeZone
            ),
            shiftEndDatetime: convertToUTCWithTimezone(
              formData.date,
              formData.endTime,
              userData?.timeZone
            ),
            priorityBasedOn: staffCriteria,
            startingTime: formData.startTime,
            endingTime: formData.endTime,
            recurringTask: isRecurring,
            recurringTasktype: selectedDays.join(","),
            instruction: formData.instruction,
            recurringShiftType: shiftType,
            type: type,
            endDate: formData.date,
            templateType: "",
            timeZone: currentTimeZone(),
          });
        });
      } else {
        const assignedTeams = selectedStaff?.map((item) => item.id);
        if (assignedTeams?.length === 0) {
          showAlert(
            "Careteam Selection Required",
            "Please select at least one careteam."
          );
          return;
        }
        clientsInGroup.forEach((elem) => {
          shiftdata.push({
            careHomeId: currentCareSiteId,
            careTeamId: assignedTeams,
            priorityBasedOn: staffCriteria,
            clientId: elem.clientId,
            // clientId: selectedidData,
            // forClient: searchInput,
            Date: formData.date,
            shiftStartDatetime: convertToUTCWithTimezone(
              formData.date,
              formData.startTime,
              userData?.timeZone
            ),
            shiftEndDatetime: convertToUTCWithTimezone(
              formData.date,
              formData.endTime,
              userData?.timeZone
            ),
            startingTime: formData.startTime,
            endingTime: formData.endTime,
            recurringTask: isRecurring,
            recurringTasktype: selectedDays.join(","),
            instruction: formData.instruction,
            recurringShiftType: shiftType,
            type: type,
            endDate: formData.date,
            templateType: "",
            timeZone: currentTimeZone(),
          });
        });
      }
    }
    const finalData = shiftdata;

    setLoading(true);
    const res = await httpAdmin("createShift", "post", finalData, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      // props.getShiftsandtaskNew("closePopup");

      let staffText = "Unassigned";
      if (isOpenShift) {
        staffText = "Open Shift";
      } else if (isAssignStaff && selectedStaff.length > 0) {
        staffText = selectedStaff.map((sItem) => sItem.name || "");
      }

      let dateText = "";
      if (isRecurring) {
        const daysWithoutAll = selectedDays.filter((d) => d !== "ALL");
        const formattedStartDate = new Date(formData.date).toLocaleDateString(
          "en-US",
          {
            month: "short",
            day: "numeric",
            year: "numeric",
          }
        );
        const formattedEndDate = new Date(formData.endDate).toLocaleDateString(
          "en-US",
          {
            month: "short",
            day: "numeric",
            year: "numeric",
          }
        );
        dateText = `${formattedStartDate} - ${formattedEndDate} (${daysWithoutAll.join(
          ", "
        )})`;
      } else {
        dateText = new Date(formData.date).toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        });
      }

      const selectedClientName = findSelectedClient?.name;

      const newShift = {
        id: res.mainshiftId ?? res.shiftId,
        mainshiftId: res.mainshiftId,
        shiftId: res.shiftId,
        client: selectedClientName,
        isRecurring,
        date: dateText,
        time: `${formData.startTime} - ${formData.endTime}`,
        staff: staffText,
      };

      setCreatedShifts([...createdShifts, newShift]);
      // Reset form
      reset();
      setSelectedDays(weekDayOptions);
      setIsAssignStaff(false);
      setIsOpenShift(false);
      setIsRecurring(false);
      setAvailableStaffData([]);
    }
    setLoading(false);
  };

  const removeShift = (shift) => {
    showConfirmModal(
      "Remove Shift",
      `Are you sure you want to remove this shift?`,
      () => {
        deleteShift(shift);
      }
    );
  };

  const deleteShift = async (shift) => {
    const shiftId = shift.shiftId;
    const mainshiftId = shift.mainshiftId;
    let idToRemove = {};
    if (shiftId) {
      idToRemove.shiftId = shiftId;
    }
    if (mainshiftId) {
      idToRemove.mainshiftId = mainshiftId;
    }
    const res = await httpAdmin(`deleteshift`, "post", idToRemove, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      setCreatedShifts((prev) =>
        prev.filter((s) => s.id !== mainshiftId && s.id !== shiftId)
      );
    }
  };

  const showConfirmModal = (title, message, onConfirm) => {
    setConfirmModal({
      show: true,
      title,
      message,
      onConfirm,
    });
  };

  const closeConfirmModal = () => {
    setConfirmModal({
      show: false,
      title: "",
      message: "",
      onConfirm: null,
    });
  };
  const handleConfirm = () => {
    if (confirmModal.onConfirm) {
      confirmModal.onConfirm();
    }
    closeConfirmModal();
  };

  const getCriteriaDisplay = (staff) => {
    if (staffCriteria === "weeklyHoursAssigned")
      return `Shift Hrs: ${staff.hours}`;
    if (staffCriteria === "distance")
      return `Distance: ${staff.distance} miles`;
    if (staffCriteria === "performance")
      return `Performance: ${staff.performance}%`;
  };

  function getCurrentDateTime(type) {
    const currentTime = moment().tz(getCurrentTimeZone()).format("HH:mm");
    const currentDate = moment().tz(getCurrentTimeZone()).format("YYYY-MM-DD");
    if (type === "date") {
      return currentDate;
    }
    return currentTime;
  }

  const closeCreationModal = () => {
    props.getShiftsandtaskNew("closePopup");
  };

  return (
    <>
      <div style={styles.modal}>
        {/* <div style={styles.modalHeader}>
          <h2 style={styles.modalTitle}>Shift Creation (Timezone used for shift creation - Europe/London)</h2>
          <button style={styles.closeBtn}>×</button>
        </div> */}

        <div style={styles.modalBody}>
          <form onSubmit={handleSubmit(addShift)}>
            {/* Basic Shift Details */}
            <div style={styles.formSection}>
              <div style={styles.sectionTitle}>Shift Details</div>

              <div style={styles.formRow}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>For:</label>
                  <select
                    style={styles.formSelect}
                    name="for"
                    {...register("for", { required: true })}
                  >
                    <option value="">Select...</option>
                    {clientOptions?.map((clientItem) => {
                      return (
                        <option key={clientItem.value} value={clientItem.value}>
                          {clientItem.name}
                        </option>
                      );
                    })}
                  </select>
                  {errors?.for?.type === "required" ? (
                    <p className="error_style">This field is required</p>
                  ) : (
                    <p className="error_style">&nbsp;</p>
                  )}
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Instructions (Optional)</label>
                  <textarea
                    style={styles.formTextarea}
                    placeholder="Enter any specific instructions for this shift..."
                    name="instruction"
                    {...register("instruction", { required: false })}
                  />
                  <p className="error_style">&nbsp;</p>
                </div>
              </div>

              <div style={styles.formRow}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Date:</label>
                  <input
                    type="date"
                    style={styles.formInput}
                    name="date"
                    min={disablePastDate(new Date())}
                    {...register("date", {
                      required: true,
                    })}
                  />
                  {errors?.date?.type === "required" ? (
                    <p className="error_style">This field is required</p>
                  ) : (
                    <p className="error_style">&nbsp;</p>
                  )}
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Starting Time:</label>
                  <select
                    style={styles.formSelect}
                    name="startTime"
                    {...register("startTime", { required: true })}
                  >
                    <option value={""}>--Select--</option>
                    {timeValues
                      .filter((item) =>
                        watch(`date`, "") <= getCurrentDateTime("date")
                          ? item.value > getCurrentDateTime("time")
                          : true
                      )
                      .map((item) => {
                        return (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        );
                      })}
                  </select>
                  {errors?.startTime?.type === "required" ? (
                    <p className="error_style">This field is required</p>
                  ) : (
                    <p className="error_style">&nbsp;</p>
                  )}
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Ending Time:</label>
                  <select
                    style={styles.formSelect}
                    name="endTime"
                    {...register("endTime", { required: true })}
                  >
                    <option value="">--Select--</option>
                    {timeValues
                      .filter((item) => {
                        return item.value > watch("startTime", "");
                      })
                      .map((item) => {
                        return (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        );
                      })}
                  </select>
                  {errors?.endTime?.type === "required" ? (
                    <p className="error_style">This field is required</p>
                  ) : (
                    <p className="error_style">&nbsp;</p>
                  )}
                </div>
              </div>

              <div style={styles.formRow}>
                <div style={styles.formGroup}>
                  <div style={styles.toggleSection}>
                    <div
                      style={{
                        ...styles.toggle,
                        ...(isRecurring ? styles.toggleActive : {}),
                      }}
                      onClick={() => setIsRecurring(!isRecurring)}
                    >
                      <div
                        style={{
                          ...styles.toggleThumb,
                          ...(isRecurring ? styles.toggleThumbActive : {}),
                        }}
                      />
                    </div>
                    <span
                      style={{
                        fontSize: "15px",
                        fontWeight: "400",
                        color: "#374151",
                        marginTop: "2px",
                      }}
                    >
                      Recurring Shift
                    </span>
                  </div>
                </div>
              </div>

              {/* Recurring Options Section */}
              <div
                style={{
                  ...styles.collapsible,
                  ...(isRecurring ? styles.collapsibleActive : {}),
                  marginTop: "16px",
                  marginBottom: 0,
                }}
              >
                <div style={styles.staffSelectionSection}>
                  <div style={styles.formRow}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Select Days:</label>
                      <div style={styles.daysSelection}>
                        {weekDayOptions.map((day) => (
                          <div key={day} style={styles.dayCheckbox}>
                            <input
                              type="checkbox"
                              id={`day-${day.toLowerCase()}`}
                              checked={selectedDays.includes(day)}
                              onChange={() => handleDayToggle(day)}
                            />
                            <label
                              style={{ fontSize: "12px", marginBottom: "0" }}
                              htmlFor={`day-${day}`}
                            >
                              {day.toUpperCase()}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div style={styles.formRow}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>End Date:</label>
                      <input
                        type="date"
                        style={styles.formInput}
                        name="endDate"
                        min={disablePastDate(
                          (() => {
                            const selectedDate = watch("date", "");
                            if (selectedDate) {
                              const date = new Date(selectedDate);
                              date.setDate(date.getDate() + 1);
                              return date;
                            }
                            return new Date();
                          })()
                        )}
                        {...register("endDate", {
                          required: isRecurring,
                        })}
                      />
                      {errors.endDate && (
                        <span className="error_style">
                          This field is required
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Shift Assignment */}
            <div style={styles.formSection}>
              <div style={styles.sectionTitle}>Shift Assignment</div>

              <div style={styles.toggleSection}>
                <div
                  style={{
                    ...styles.toggle,
                    ...(isOpenShift ? styles.toggleActive : {}),
                  }}
                  onClick={() => {
                    setIsOpenShift(!isOpenShift);
                    if (!isOpenShift) setIsAssignStaff(false);
                  }}
                >
                  <div
                    style={{
                      ...styles.toggleThumb,
                      ...(isOpenShift ? styles.toggleThumbActive : {}),
                    }}
                  />
                </div>
                <span
                  style={{
                    fontSize: "15px",
                    fontWeight: "400",
                    color: "#374151",
                    marginTop: "2px",
                  }}
                >
                  Open Shift
                </span>
              </div>

              <div style={styles.toggleSection}>
                <div
                  style={{
                    ...styles.toggle,
                    ...(isAssignStaff ? styles.toggleActive : {}),
                  }}
                  onClick={() => {
                    setIsAssignStaff(!isAssignStaff);
                    if (!isAssignStaff) setIsOpenShift(false);
                  }}
                >
                  <div
                    style={{
                      ...styles.toggleThumb,
                      ...(isAssignStaff ? styles.toggleThumbActive : {}),
                    }}
                  />
                </div>
                <span
                  style={{
                    fontSize: "15px",
                    fontWeight: "400",
                    color: "#374151",
                    marginTop: "2px",
                  }}
                >
                  Assign Staff (Optional)
                </span>
              </div>

              {/* Open Shift Section */}
              <div
                style={{
                  ...styles.collapsible,
                  ...(isOpenShift ? styles.collapsibleActive : {}),
                }}
              >
                <div style={styles.staffSelectionSection}>
                  <div style={styles.formGroup}>
                    <label>
                      Open Shift - Available for any qualified carer to pick up
                    </label>
                  </div>
                </div>
              </div>

              {/* Staff Assignment Section */}
              <div
                style={{
                  ...styles.collapsible,
                  ...(isAssignStaff ? styles.collapsibleActive : {}),
                }}
              >
                <div style={styles.staffSelectionSection}>
                  <div style={styles.staffFilters}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>
                        CareTeam Selection Criteria:
                      </label>
                      <select
                        style={styles.formSelect}
                        value={staffCriteria}
                        onChange={(e) => setStaffCriteria(e.target.value)}
                      >
                        <option value="weeklyHoursAssigned">
                          Assigned Shift Hours
                        </option>
                        <option value="distance">Distance</option>
                        <option value="performance">Performance</option>
                      </select>
                    </div>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Job Title Filter:</label>
                      <select
                        style={styles.formSelect}
                        value={jobTitleFilter}
                        onChange={(e) => setJobTitleFilter(e.target.value)}
                      >
                        <option value="all">All Job Title</option>
                        {jobTitleOptions.map((item) => {
                          return (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>

                  <div style={styles.staffList}>
                    {availableStaffData?.length > 0 ? (
                      availableStaffData.map((staff) => (
                        <div key={staff.id} style={styles.staffItem}>
                          <div style={styles.staffInfo}>
                            <div style={styles.staffAvatar}>
                              {staff.image ? (
                                <img
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    objectFit: "cover",
                                    borderRadius: "25px",
                                  }}
                                  src={staff.image}
                                  alt="img"
                                />
                              ) : (
                                staff.avatar
                              )}
                            </div>
                            <div style={styles.staffDetails}>
                              <div style={styles.staffName}>{staff.name}</div>
                              <div style={styles.staffRole}>{staff.role}</div>
                              <div style={styles.staffCriteria}>
                                {getCriteriaDisplay(staff)}
                              </div>
                            </div>
                          </div>
                          <button
                            type="button"
                            style={{
                              ...styles.selectBtn,
                              ...(staff.selected
                                ? styles.selectBtnSelected
                                : {}),
                            }}
                            onClick={() => handleStaffToggle(staff.id)}
                          >
                            {staff.selected ? "Selected" : "Select"}
                          </button>
                        </div>
                      ))
                    ) : (
                      <div>
                        No Careteam available for selected time and filters.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Add Shift Button */}
            <div style={styles.addShiftSection}>
              <button
                style={{ ...styles.btn, ...styles.btnPrimary }}
                type="submit"
              >
                {loading ? (
                  <LoadingBtn style={{ width: "16px", height: "16px" }} />
                ) : (
                  "Create Shift"
                )}
              </button>
            </div>
          </form>

          {/* Created Shifts Section */}
          <div style={styles.formSection}>
            <div style={styles.sectionTitle}>Created Shifts</div>
            <div style={styles.createdShifts}>
              {createdShifts.length > 0 ? (
                createdShifts.map((shift) => (
                  <div key={shift.id} style={styles.shiftItem}>
                    <div style={styles.shiftInfo}>
                      <div style={styles.shiftName}>
                        Shift for {shift.client}
                        <span
                          style={{
                            ...styles.shiftTypeBadge,
                            ...(shift.isRecurring
                              ? styles.shiftTypeRecurring
                              : styles.shiftTypeSingle),
                          }}
                        >
                          {shift.isRecurring ? "Recurring" : "Single"}
                        </span>
                      </div>
                      <div style={styles.shiftDetails}>
                        {shift.date} • {shift.time}
                      </div>
                      <div style={styles.shiftStaff}>
                        Staff:{" "}
                        {Array.isArray(shift.staff)
                          ? shift.staff.join(", ")
                          : shift.staff}
                      </div>
                    </div>
                    <button
                      style={styles.removeBtn}
                      onClick={() => removeShift(shift)}
                    >
                      Remove
                    </button>
                  </div>
                ))
              ) : (
                <div style={styles.emptyState}>
                  No shifts created yet. Create your first shift above.
                </div>
              )}
            </div>
          </div>

          {/* Action Buttons */}
          <div style={styles.actionButtons}>
            <button
              onClick={closeCreationModal}
              style={{ ...styles.btn, ...styles.btnSecondary }}
            >
              Cancel
            </button>
            <button
              onClick={closeCreationModal}
              style={{ ...styles.btn, ...styles.btnPrimary }}
            >
              Done
            </button>
          </div>
        </div>
      </div>

      {/* Confirmation Modal */}
      {confirmModal.show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: "12px",
              width: "400px",
              maxWidth: "90%",
              boxShadow: "0 20px 40px rgba(0, 0, 0, 0.3)",
            }}
          >
            <div
              style={{
                background: "#8b5cf6",
                color: "white",
                padding: "16px 20px",
                borderRadius: "12px 12px 0 0",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                }}
              >
                Alert
              </div>
              <button
                onClick={closeConfirmModal}
                style={{
                  background: "none",
                  border: "none",
                  color: "white",
                  fontSize: "24px",
                  cursor: "pointer",
                  padding: 0,
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                ×
              </button>
            </div>
            <div
              style={{
                padding: "30px 20px",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  color: "#7c2d12",
                  marginBottom: "15px",
                }}
              >
                {confirmModal.title}
              </div>
              <div
                style={{
                  fontSize: "14px",
                  color: "#6b7280",
                  lineHeight: 1.5,
                  marginBottom: "25px",
                }}
              >
                {confirmModal.message}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={closeConfirmModal}
                  style={{
                    background: "#f3f4f6",
                    color: "#374151",
                    border: "1px solid #d1d5db",
                    padding: "12px 24px",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: "pointer",
                    minWidth: "80px",
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleConfirm}
                  style={{
                    background: "#8b5cf6",
                    color: "white",
                    border: "none",
                    padding: "12px 24px",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: "pointer",
                    minWidth: "80px",
                  }}
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Custom Alert Modal */}
      {alertModal.show && (
        <div style={styles.alertModal}>
          <div style={styles.alertContent}>
            <div style={styles.alertHeader}>
              <div style={styles.alertTitle}>Alert</div>
              <button
                style={styles.alertClose}
                onClick={() =>
                  setAlertModal({ show: false, title: "", message: "" })
                }
              >
                ×
              </button>
            </div>
            <div style={styles.alertBody}>
              <div style={styles.alertIcon}>!</div>
              <div style={styles.alertMessageTitle}>{alertModal.title}</div>
              <div style={styles.alertMessage}>{alertModal.message}</div>
              <button
                style={styles.alertOkBtn}
                onClick={() =>
                  setAlertModal({ show: false, title: "", message: "" })
                }
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ShiftCreationAgency;

const sortArrayByKey = (arr, key) => {
  return [...arr].sort((a, b) => {
    const valA = Number(a[key]);
    const valB = Number(b[key]);
    if (key === "performance") {
      return valB - valA;
    }
    return valA - valB;
  });
};

const styles = {
  modal: {
    background: "white",
    // borderRadius: '12px',
    // maxWidth: '900px',
    width: "100%",
    maxHeight: "70vh",
    overflowY: "auto",
    // boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
    margin: "20px auto",
  },
  modalHeader: {
    padding: "24px 24px 0 24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
  },
  modalTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#1f2937",
  },
  closeBtn: {
    background: "none",
    border: "none",
    fontSize: "24px",
    cursor: "pointer",
    color: "#6b7280",
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "6px",
    transition: "background-color 0.2s",
  },
  modalBody: {
    padding: "0 24px 24px 24px",
  },
  formSection: {
    marginBottom: "32px",
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#374151",
    marginBottom: "16px",
  },
  formRow: {
    display: "flex",
    gap: "16px",
    marginBottom: "16px",
    alignItems: "flex-start",
  },
  formGroup: {
    flex: 1,
  },
  label: {
    display: "block",
    marginBottom: "6px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#374151",
  },
  formInput: {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    fontSize: "14px",
    transition: "border-color 0.2s",
    background: "white",
    height: "44px",
    boxSizing: "border-box",
  },
  formSelect: {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    fontSize: "14px",
    transition: "border-color 0.2s",
    background: "white",
    height: "44px",
    boxSizing: "border-box",
    cursor: "pointer",
  },
  formTextarea: {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    fontSize: "14px",
    transition: "border-color 0.2s",
    resize: "vertical",
    height: "44px",
    fontFamily: "inherit",
    boxSizing: "border-box",
  },
  daysSelection: {
    display: "flex",
    gap: "12px",
    marginTop: "8px",
    flexWrap: "wrap",
  },
  dayCheckbox: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  toggleSection: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "12px",
  },
  toggle: {
    position: "relative",
    width: "44px",
    height: "24px",
    background: "#d1d5db",
    borderRadius: "12px",
    cursor: "pointer",
    transition: "background 0.2s",
  },
  toggleActive: {
    background: "#9e61e7",
  },
  toggleThumb: {
    position: "absolute",
    width: "20px",
    height: "20px",
    background: "white",
    borderRadius: "50%",
    top: "2px",
    left: "2px",
    transition: "transform 0.2s",
  },
  toggleThumbActive: {
    transform: "translateX(20px)",
  },
  collapsible: {
    maxHeight: "0",
    overflow: "hidden",
    transition: "max-height 0.3s ease",
  },
  collapsibleActive: {
    maxHeight: "500px",
  },
  staffSelectionSection: {
    background: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "16px",
    marginTop: "12px",
  },
  staffFilters: {
    display: "flex",
    gap: "12px",
    marginBottom: "16px",
    flexWrap: "wrap",
  },
  staffList: {
    maxHeight: "250px",
    overflowY: "auto",
    border: "1px solid #e5e7eb",
    borderRadius: "6px",
    padding: "8px",
    background: "white",
  },
  staffItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 12px",
    marginBottom: "6px",
    borderRadius: "6px",
    transition: "background 0.2s",
    minHeight: "60px",
  },
  staffItemHover: {
    background: "#f9fafb",
  },
  staffInfo: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: 1,
    minWidth: 0,
  },
  staffAvatar: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    background: "#9e61e7",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontSize: "12px",
    fontWeight: "600",
    flexShrink: 0,
  },
  staffDetails: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    flex: 1,
  },
  staffName: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#1f2937",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  staffRole: {
    fontSize: "12px",
    color: "#6b7280",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  staffCriteria: {
    fontSize: "11px",
    color: "#059669",
    fontWeight: "500",
    marginTop: "2px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  selectBtn: {
    padding: "4px 12px",
    fontSize: "12px",
    borderRadius: "4px",
    border: "1px solid #9e61e7",
    background: "white",
    color: "#9e61e7",
    cursor: "pointer",
    transition: "all 0.2s",
    whiteSpace: "nowrap",
  },
  selectBtnSelected: {
    background: "#9e61e7",
    color: "white",
  },
  createdShifts: {
    background: "#f9fafb",
    borderRadius: "8px",
    padding: "16px",
    marginBottom: "16px",
    minHeight: "100px",
    maxHeight: "300px",
    overflowY: "auto",
  },
  shiftItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "white",
    padding: "12px",
    borderRadius: "6px",
    marginBottom: "8px",
    border: "1px solid #e5e7eb",
  },
  shiftInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    flex: 1,
    minWidth: 0,
  },
  shiftName: {
    fontWeight: "500",
    color: "#1f2937",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  shiftDetails: {
    fontSize: "12px",
    color: "#6b7280",
    wordWrap: "break-word",
  },
  shiftStaff: {
    fontSize: "12px",
    color: "#059669",
    wordWrap: "break-word",
  },
  shiftTypeBadge: {
    display: "inline-block",
    padding: "2px 8px",
    borderRadius: "12px",
    fontSize: "10px",
    fontWeight: "600",
    textTransform: "uppercase",
    flexShrink: 0,
  },
  shiftTypeRecurring: {
    background: "#dbeafe",
    color: "#1e40af",
  },
  shiftTypeSingle: {
    background: "#fef3c7",
    color: "#92400e",
  },
  removeBtn: {
    background: "#fee2e2",
    color: "#dc2626",
    padding: "4px 8px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "12px",
    transition: "background-color 0.2s",
    flexShrink: 0,
  },
  btn: {
    padding: "10px 20px",
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s",
  },
  btnPrimary: {
    background: "#9e61e7",
    color: "white",
  },
  btnSecondary: {
    background: "#f3f4f6",
    color: "#374151",
    border: "1px solid #d1d5db",
  },
  actionButtons: {
    display: "flex",
    gap: "12px",
    justifyContent: "flex-end",
    marginTop: "24px",
    paddingTop: "24px",
    borderTop: "1px solid #e5e7eb",
  },
  addShiftSection: {
    display: "flex",
    justifyContent: "flex-start",
    marginBottom: "24px",
  },
  emptyState: {
    textAlign: "center",
    color: "#6b7280",
    fontSize: "14px",
    padding: "24px",
  },
  alertModal: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.8)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
  },
  alertContent: {
    background: "white",
    borderRadius: "12px",
    width: "400px",
    maxWidth: "90%",
    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.3)",
    overflow: "hidden",
  },
  alertHeader: {
    background: "#8b5cf6",
    color: "white",
    padding: "16px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  alertTitle: {
    fontSize: "18px",
    fontWeight: "600",
  },
  alertClose: {
    background: "none",
    border: "none",
    color: "white",
    fontSize: "24px",
    cursor: "pointer",
    padding: 0,
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "background-color 0.2s",
  },
  alertBody: {
    padding: "30px 20px",
    textAlign: "center",
  },
  alertIcon: {
    width: "60px",
    height: "60px",
    background: "#f59e0b",
    borderRadius: "50%",
    margin: "0 auto 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "30px",
    color: "white",
    fontWeight: "bold",
  },
  alertMessageTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#92400e",
    marginBottom: "15px",
  },
  alertMessage: {
    fontSize: "14px",
    color: "#6b7280",
    lineHeight: 1.5,
    marginBottom: "25px",
  },
  alertOkBtn: {
    background: "#9e61e7",
    color: "white",
    border: "none",
    padding: "12px 24px",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    minWidth: "80px",
    transition: "background-color 0.2s",
  },
};
